import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../config/theme';

const COOKIE_KEY = 'cookie_notice';

/**
 * Avviso informativo sui cookie.
 * La piattaforma usa solo strumenti tecnici (vedi CookiePolicyPage), quindi non serve
 * raccogliere un consenso: il cookie ricorda solo che l'avviso è stato letto.
 */
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hasConsent = document.cookie.includes(`${COOKIE_KEY}=`);
    if (!hasConsent) {
      setVisible(true);
    }
  }, []);

  const setConsent = (value) => {
    document.cookie = `${COOKIE_KEY}=${value}; path=/; max-age=31536000; SameSite=Lax`;
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner fixed bottom-0 inset-x-0 z-50 bg-white border-t shadow-lg" style={{ borderColor: COLORS.border }}>
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row gap-3 items-center justify-between text-sm">
        <p style={{ color: COLORS.text2 }}>
          Questa piattaforma utilizza solo cookie e strumenti tecnici necessari al suo funzionamento.
          Non utilizziamo cookie di profilazione n&eacute; strumenti di analisi statistica. Per
          maggiori informazioni leggi la Cookie Policy.
        </p>
        <div className="flex gap-3 items-center flex-shrink-0">
          <Link
            to="/cookie-policy"
            className="inline-flex items-center px-4 py-2 underline"
            style={{ color: COLORS.primary }}
          >
            Cookie Policy
          </Link>
          <button
            onClick={() => setConsent('acknowledged')}
            className="px-4 py-2 text-white rounded-md"
            style={{ backgroundColor: COLORS.primary }}
          >
            Ho capito
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
